import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField } from '@mui/material';
import { Alert, Button, Stack } from '../design-system';
import { useAuth } from '../context/AuthContext';
import { AuthLayout } from './LoginPageModern';

export default function ResetPasswordPage() {
  const { updatePassword } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState('');
  const submit = async (event) => {
    event.preventDefault();
    if (password.length < 8) return setError('La contraseña debe tener al menos 8 caracteres.');
    if (password !== confirmation) return setError('Las contraseñas no coinciden.');
    try {
      await updatePassword(password);
      navigate('/dashboard', { replace: true });
    } catch (updateError) { setError(updateError.message || 'No se pudo cambiar la contraseña.'); }
  };
  return <AuthLayout title="Elige una contraseña nueva" subtitle="Protege tu cuenta con una contraseña segura">
    <Stack component="form" onSubmit={submit} spacing={2}>
      {error && <Alert severity="error">{error}</Alert>}
      <TextField label="Nueva contraseña" type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="new-password" required fullWidth />
      <TextField label="Confirmar contraseña" type="password" value={confirmation} onChange={(event) => setConfirmation(event.target.value)} autoComplete="new-password" required fullWidth />
      <Button type="submit" variant="contained">Guardar contraseña</Button>
    </Stack>
  </AuthLayout>;
}
